import script from "./Screenshot.vue?vue&type=script&setup=true&lang=js"
export * from "./Screenshot.vue?vue&type=script&setup=true&lang=js"

import "./Screenshot.vue?vue&type=style&index=0&id=36c298ab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.69.1_uglify-js@3.15.2_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c298ab"]])

export default __exports__